export default __webpack_public_path__ + "static/media/logo-white.0b345b37.svg";